import { DocumentCollection, DocumentResource, IRelationships, Resource } from 'ngx-jsonapi';
import { File } from './file';
import { ValidationType } from './validation-type';

export class Validation extends Resource {
    public type: string = 'validations';
    public attributes: {
        status: string;
        observations: string;
        validation_type_id: string;
        validable_type: string;
        validable_id: string;
        created_at: string;
    } = {
        status: '',
        observations: '',
        validation_type_id: '',
        validable_type: 'user',
        validable_id: '0',
        created_at: ''
    };

    public relationships: IRelationships = {
        validation_type: new DocumentResource<ValidationType>(),
        files: new DocumentCollection<File>()
    };
}
